import { apiRequest, apiRequestDev } from './apiRequest';

export const login = async (config, email, password) => {
  return apiRequest(config, '/auth/login', 'post', {
    email,
    password,
    project: 2,
    demo: config.demo,
  });
};

export const sendEmailVerificationCode = async (config, userId) => {
  return apiRequestDev(config, '/auth/verification_email', 'post', {
    user_id: userId,
  });
};

export const validateEmailVerificationCode = async (config, userId, userCode) => {
  return apiRequestDev(config, '/auth/verification_email/validate', 'post', {
    user_id: userId,
    user_code: userCode,
  });
};

export const sendSmsVerificationCode = async (config, phone) => {
  return apiRequestDev(config, '/auth/verification_sms', 'post', {
    phone,
  });
};

export const validateSmsVerificationCode = async (config, phone, code) => {
  return apiRequestDev(config, '/auth/verification_sms/validate', 'post', {
    phone,
    code,
  });
};
